// src/components/common/SplitFlapText.tsx
import { Box, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useEffect, useState, useRef } from "react";
import { useInView } from "framer-motion";

interface SplitFlapTextProps {
  value: string;
  duration?: number; // tiempo total de animación (ms)
  fontSize?: { xs: string; md: string; lg: string }; // tamaños responsivos
}

const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$+%";

const SplitFlapText: React.FC<SplitFlapTextProps> = ({
  value,
  duration = 1000,
  fontSize = { xs: "2.5rem", md: "3rem", lg: "3.5rem" },
}) => {
  const theme = useTheme();
  const [displayed, setDisplayed] = useState<string[]>(value.split(""));
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (!isInView) return;

    const finalChars = value.split("");
    const interval = 50;
    let frame = 0;

    const timer = setInterval(() => {
      setDisplayed((prev) =>
        prev.map((_, i) =>
          frame < duration / interval
            ? characters[Math.floor(Math.random() * characters.length)]
            : finalChars[i]
        )
      );
      frame++;
      if (frame > duration / interval) clearInterval(timer);
    }, interval);

    return () => clearInterval(timer);
  }, [isInView, value, duration]);

  return (
    <Box
      ref={ref}
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: 0.5,
      }}
    >
      {displayed.map((char, i) => (
        <motion.span
          key={i}
          initial={{ rotateX: -90 }}
          animate={{ rotateX: 0 }}
          transition={{ duration: 0.3 }}
          style={{
            fontWeight: 700,
            color: theme.palette.primary.main,
            fontSize: fontSize.xs,
          }}
        >
          {char}
        </motion.span>
      ))}
    </Box>
  );
};

export default SplitFlapText;
